import { ACADEMY_CATALOG_SERVICE_URI_V2 } from '../../constants/ApiConstants';
import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import http from 'hub-http/clients/apiClient';
import { useCallback, useMemo } from 'react';
import { GET_PLAYLIST_PROGRESS } from '../userProgress/userProgressQueries';
import { MY_LEARNING_QUERY_FIELD_NAME } from '../myLearning/myLearningQueries';
import Raven from 'raven-js';
import { useStartShortProgress } from 'academy-common-lib/features/userProgress/hooks/useStartShortProgress';
import { GET_CATALOG_RESOURCES_QUERY } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService.dfc.new';
import { GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY } from '../../../__generated__/chirp/com/hubspot/userprogress/bff/rpc/UserProgressBFFChirpService.dfc.new';
import { convertToSupportedLanguage } from 'academy-common-lib/constants/academySupportedLanguages';
import { CatalogShortFormContentResponseTypename } from '../../../__generated__/chirp/com/hubspot/academy/catalog/rpc/v1/CatalogResourceChirpFrontendService';
export const SHORTS_API = `${ACADEMY_CATALOG_SERVICE_URI_V2}/shorts/`;
export const useFullShort = (shortId, skip) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_CATALOG_RESOURCES_QUERY, {
    skip,
    variables: {
      requestedResources: [{
        resourceId: shortId,
        type: 'SHORT_FORM_CONTENT'
      }]
    }
  });
  const short = useMemo(() => {
    var _data$results;
    if (!(data !== null && data !== void 0 && (_data$results = data.results) !== null && _data$results !== void 0 && _data$results.length)) return undefined;
    const result = data.results[0];
    if (result.__typename === CatalogShortFormContentResponseTypename) return result;
    return undefined;
  }, [data]);
  return {
    short,
    shortLoading: loading,
    shortError: error
  };
};
const GET_ALL_SHORTS = registerQuery({
  fieldName: 'shorts',
  args: [],
  fetcher: () => http.get(`${SHORTS_API}`)
});
export const useAllShorts = skip => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_ALL_SHORTS, {
    skip,
    variables: {}
  });
  return {
    allShorts: data,
    allShortsLoading: loading,
    allShortsError: error
  };
};
export const useShort = (shortId, skip) => {
  const {
    allShorts,
    allShortsLoading,
    allShortsError
  } = useAllShorts(skip);
  const short = useMemo(() => (allShorts === null || allShorts === void 0 ? void 0 : allShorts.find) && allShorts.find(s => s.contentId === shortId), [allShorts, shortId]);
  return {
    short,
    shortLoading: allShortsLoading,
    shortError: allShortsError
  };
};
export const useStartShort = (shortId, language, playlistId) => {
  const [mutate, {
    loading: startShortLoading,
    called: startShortCalled,
    error: startShortError,
    data: startShortData
  }] = useStartShortProgress();
  const startShort = useCallback(() => {
    return mutate({
      awaitRefetchQueries: true,
      variables: {
        shortId,
        language,
        playlistId
      },
      refetchQueries: [{
        query: GET_ALL_USER_PROGRESS_BY_USER_ID_QUERY,
        variables: {
          language: convertToSupportedLanguage(language)
        },
        context: {
          timeout: 25000
        }
      }, ...(playlistId ? [{
        query: GET_PLAYLIST_PROGRESS,
        variables: {
          playlistId
        }
      }] : [])],
      update: (cache, result) => {
        const {
          data,
          errors
        } = result;
        if (!data || errors && errors.length) return;
        cache.evict({
          fieldName: MY_LEARNING_QUERY_FIELD_NAME
        });
      },
      onError(error) {
        Raven.captureException(error);
      }
    });
  }, [language, mutate, playlistId, shortId]);
  return [startShort, {
    startShortLoading,
    startShortCalled,
    startShortError,
    startShortData
  }];
};